import React from "react";
import { useHistory } from "react-router-dom";

import { App } from "../../../../routes/Constants";

import Line from "../../../../assets/icons/line.svg";
import { ReactComponent as ArrowNextWhite } from "../../../../assets/icons/arrowNextWhite.svg";

export const ReferAPatient = ({ isPharmacy }) => {
  const history = useHistory();
  return (
    <div className="col first">
      <img src={Line} alt="White Line" />
      <div className="main-text font-size-30 bold">
        {isPharmacy ? "Convert to a digital PAF" : "Generate a PAF"}
      </div>
      <div className="second-text font-size-16">
        {isPharmacy
          ? "Generate a digital PAF if you have received a paper PAF"
          : "For new patients"}
      </div>
      <button
        className="primary-button"
        onClick={() => {
          history.push(App.PATIENT_INITIATION);
        }}
      >
        {isPharmacy ? "Generate digital PAF" : "Generate a PAF"}{" "}
        <ArrowNextWhite />{" "}
      </button>
    </div>
  );
};
